import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Typography } from '@mui/material'

import { Organization } from 'types/organization'

import s from './styles'

interface Props {
  organization: Organization
}

const OrganizationMainInfo: FC<Props> = ({ organization }) => {
  const { t } = useTranslation()

  return (
    <>
      <Box>
        <Typography sx={s.labelText}>{t('Pages.Organizations.DateOfCreation')}: </Typography>
        <Typography sx={s.valueText}>{organization.name}</Typography>
      </Box>
      <Box>
        <Typography sx={s.labelText}>{t('Pages.Organizations.CreatedBy')}: </Typography>
        <Typography sx={s.valueText}>{organization.creatorUsername}</Typography>
      </Box>
      <Box>
        <Typography sx={s.labelText}>{t('Pages.Organizations.OrganizationOwner')}: </Typography>
        <Typography sx={s.valueText}>{organization.ownerUsername}</Typography>
      </Box>
    </>
  )
}

export default OrganizationMainInfo
